class Tabs {
  constructor() {
    this.tabs = document.querySelectorAll('.tabs');
    this.innerTabs = document.querySelectorAll('.inner-tabs');
    if(this.tabs.length) this.init();
    if(this.innerTabs.length) this.initInner();
  }

  init = () => {
    this.tabs.forEach(tab => {
      const tabButtonsWrap = tab.querySelector('.tabs-buttons');
      const tabButtons = tab.querySelectorAll('.tab-button[role="tab"]');
      const selectOptions = tab.querySelector('select.offers-tabs-select');
      const tabsSelector = tab.querySelector('.tabs-selector');
      const tabPanels = Array.from(tab.querySelectorAll('.tab-content[role="tabpanel"]'));

      if(selectOptions) {
        selectOptions.addEventListener("change", selectOptionsChange);
      }
      if(tabsSelector){
        tabsSelector.addEventListener('click', tabsSelectorToggle);
      }

      tabButtons.forEach(button => {
        button.addEventListener('click', tabClickHandler);
      })

      function tabsSelectorToggle() {
        if(tabButtonsWrap.classList.contains('expanded')) {
          tabButtonsWrap.classList.remove('expanded')
        } else {
          tabButtonsWrap.classList.add('expanded')
        }
      }

      function selectOptionsChange(e) {
        tabClickHandler(null, e.target.value)
      }

      function tabClickHandler(e, targetValue) {
        //Hide All Tabpane
        tabPanels.forEach(panel => {
          panel.hidden = 'true';
        });

        //Deselect Tab Button
        tabButtons.forEach( button => {
          button.setAttribute('aria-selected', 'false');
        });

        //Mark New Tab
        if(targetValue) {
          tab.querySelector('#' + targetValue).setAttribute('aria-selected', 'true');
        } else {
          e.currentTarget.setAttribute('aria-selected', 'true');
          if(tabsSelector){
            tabsSelector.innerHTML = e.currentTarget.innerHTML;
          }
        }

        //Show New Tab
        let id;
        if(targetValue) {
          id = targetValue;
        } else {
          id = e.currentTarget.id;
          if(selectOptions) {
            selectOptions.value = id;
          }
        }

        const currentTab = tabPanels.find(
          panel => panel.getAttribute('aria-labelledby') === id
        );

        currentTab.hidden = false;
        if(tabsSelector){
          tabsSelectorToggle();
        }

        //Set new or modify existing url parameter value.
        var queryParams = new URLSearchParams(window.location.search);
        queryParams.set("tab", id.replace('tab-', ''));
        history.pushState(null, null, "?"+queryParams.toString());
      }
    });
  }

  initInner = () => {
    this.innerTabs.forEach(tab => {
      const tabButtons = tab.querySelectorAll('.inner-tab-button[role="tab"]');
      const tabPanels = Array.from(tab.querySelectorAll('.inner-tab-content[role="tabpanel"]'));

      tabButtons.forEach(button => {
        button.addEventListener('click', tabClickHandler);
      })

      function tabClickHandler(e, targetValue) {
        //Hide All Tabpane
        tabPanels.forEach(panel => {
          panel.hidden = 'true';
        });

        //Deselect Tab Button
        tabButtons.forEach( button => {
          button.setAttribute('aria-selected', 'false');
        });

        //Mark New Tab
        if(targetValue) {
          tab.querySelector('#' + targetValue).setAttribute('aria-selected', 'true');
        } else {
          e.currentTarget.setAttribute('aria-selected', 'true');
        }

        //Show New Tab
        let id;
        if(targetValue) {
          id = targetValue;
        } else {
          id = e.currentTarget.id;
        }

        const currentTab = tabPanels.find(
          panel => panel.getAttribute('aria-labelledby') === id
        );

        currentTab.hidden = false;
      }
    });
  }
}

jQuery(() => {
  new Tabs();
});
